"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createUnitFormat = exports.getUnitFormat = void 0;
/**
 * Get formatting info from unit
 * @param unit
 */
function getUnitFormat(unit, unitsFormat) {
    return unitsFormat[unit.name];
}
exports.getUnitFormat = getUnitFormat;
/**
 * Creates a unit format
 * @param label
 * @param decimalCount
 */
function createUnitFormat(label, decimalCount) {
    return {
        label: label,
        decimalCount: decimalCount,
    };
}
exports.createUnitFormat = createUnitFormat;
//# sourceMappingURL=unit-format.js.map